export default __webpack_public_path__ + "static/media/step3aLightMode.7f2e9ba8.svg";